var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles",class:[_vm.class_name]},_vm._l((_vm.content),function(text,i){return _c('div',{key:i,staticClass:"item"},[_c('span',{staticClass:"tx"},[_vm._v(_vm._s(text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }